import React from "react";
import "./certificate.css";
import { Data } from "./Data";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// Import required modules
import { Autoplay,Pagination } from "swiper";

const Certificate = () => {
  return (
    <section className="certificate container section" id="certificate">
      <h2 className="section__title">My Certification</h2>
      <span className="section__subtitle">What i'm doing so far</span>

      <Swiper
        className="certificate__container"
        grabCursor={true}
        spaceBetween={24}
        autoplay={{
          delay: 2500,
        }}
        loop={true}
        pagination={{ clickable: true }}
        breakpoints={{
          576: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 48,
          },
        }}
        modules={[Autoplay,Pagination]}
      >
        {Data.map(({ id, image, title, description }) => {
          return (
            <SwiperSlide className="certificate__card" key={id}>
              <img src={image} alt="" className="certificate__img" />

              <h3 className="certificate__name">{title}</h3>
              <p className="certificate__description">{description}</p>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default Certificate;
